<template>
    <v-content>
        <v-app>
            <v-container grid-list-md fluid>
                <v-layout row wrap>
                    <v-flex xs2>
                        <form enctype="multipart/form-data">
                            <input type="file" ref="file" style="display:none" @change="onFileChange">
                        </form>
                        <v-text-field v-model="fileName" @click="selectFile" append-icon="attach_file" label="File Input" readonly></v-text-field>
                        
                    </v-flex>
                    <v-flex xs1>
                        <v-btn :disabled="uploadDisabled" id="upload-btn" color="primary" @click="uploadFile">Upload</v-btn>
                    </v-flex>
                </v-layout>

                <v-layout>
                    <v-flex xs12>
                        <v-snackbar v-model="snackbar">
                            File must be .CSV format.
                            <v-btn flat dark text @click="snackbar = false">Close</v-btn>
                        </v-snackbar>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </v-content>
</template>

<script>
import Papa from 'papaparse';
import axios from 'axios';
import sweetAlert from '../sweetAlert.js';

export default {
    data() {
        return {
            fileName: null,
            snackbar: false,
            uploadDisabled: true,
            tableHeaders: [],
            tableData: []
        }
    },
    mixins: [ sweetAlert ],
    methods: {
        selectFile() {
            this.$refs.file.click();
        },
        onFileChange(e) {
            const regex = new RegExp("(.*?)\.(csv)$");
            if (!(regex.test(e.target.files[0].name.toLowerCase()))) {
                this.snackbar = true;
            }
            else {
                this.fileName = e.target.files[0].name;
                this.uploadDisabled = false;

                const config = { header: true,
                                 complete:(res) => {

                                    res.meta.fields.forEach(row => {
                                        this.tableHeaders.push({ text: row, value: row, sortable: false });
                                    })

                                    res.data.forEach((row, key, i) => {
                                        this.tableData.push(row);
                                    })
                                 }};
                Papa.parse(e.target.files[0], config);
                console.log(this.tableData);
            }
        },
        uploadFile() {
            axios({
            method: 'post',
            url: 'https://controlapi.totalprocessing.com/api/invoices-upload-csv',
            data: { csv: this.tableData },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                if(response.data == 'Success') {
                    let result = { data: 'invoices-csv-success' };
                    this.sweetAlert(result);
                }
                else {
                    let result = { data: 'invoices-csv-fail' };
                    this.sweetAlert(result);
                }
            })
            .catch(e => {
                let result = { data: 'invoices-csv-fail' };
                this.sweetAlert(result);
            })
        }
    }
}
</script>

<style>
    #upload-btn {
        margin-top: 12px;
    }
</style>
